import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Row,
} from 'reactstrap';
import { toastr } from 'react-redux-toastr';

import ApiHelper from 'utils/apiHelper';
import * as constants from 'utils/constants';
import * as yup from 'yup';
import { passwordRequirements } from 'utils/schema';
import PasswordRequirements from 'components/PasswordRequirements';

class PasswordReset extends Component {
  constructor(props) {
    super(props);
    this.parameters = null;
    this.state = {
      loadingShow: false,
      linkIsInvalid: false,
      errors: {
        password: '',
        confirmPassword: '',
      },
      inputs: {
        password: '',
        confirmPassword: '',
      },
    };
  }

  UNSAFE_componentWillMount() {
    this.parameters = new URLSearchParams(this.props.location.search);
    if (!this.parameters.has('token')) {
      this.props.history.push('/login');
    }
  }

  handleChangeInput = (e) => {
    let errors = this.state.errors;
    if (errors[e.target.name] !== '') {
      errors[e.target.name] = '';
      this.setState(errors);
    }

    this.setState({
      inputs: {
        ...this.state.inputs,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { password, confirmPassword } = this.state.inputs;

    let errors = this.state.errors;

    if (password === '') {
      errors.password = 'New password is required.';
      this.setState({ errors });
      return;
    }

    if (confirmPassword === '') {
      errors.confirmPassword = 'Confirm password is required.';
      this.setState({ errors });
      return;
    }

    if (password !== confirmPassword) {
      errors.confirmPassword = 'Password does not match.';
      this.setState({ errors });
      return;
    }

    // region password requirements
    const requirements = passwordRequirements({
      email: '',
      username: '',
    });
    try {
      requirements.schema.validateSync(password);
    } catch (error) {
      if (error instanceof yup.ValidationError) {
        const [msg] = error.errors;
        errors.password = msg;
        this.setState(errors);
      }
      return;
    }
    // endregion

    this.setState({ loadingShow: true });
    ApiHelper.post(
      '/api/auth/password_reset/confirm/',
      {
        password: password,
        token: this.parameters.get('token'),
      },
      {},
      false,
    )
      .then((res) => {
        toastr.success('Success!', 'Successfully reset the password.');
        this.props.history.push('/login');
      })
      .catch((err) => {
        const response = err.response;
        if (response.status === 400) {
          for (let key in response.data) {
            errors[key] = response.data[key][0];
          }
        } else {
          toastr.error('Fail!', 'The link is invalid or expired.');
        }
        this.setState({ errors });
      })
      .finally(() => {
        this.setState({ loadingShow: false });
      });
  };

  render() {
    const { logoUrl } = this.props;
    const { errors, loadingShow } = this.state;

    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                      <div className="text-center">
                        <Link to="/">
                          <img src={logoUrl} height={150} alt="logo" />
                        </Link>
                      </div>
                      <div className="text-center">
                        <span className="h5">Reset your password</span>
                      </div>
                      <FormGroup className="mt-2">
                        <InputGroup className="mb-4">
                          <InputGroupText>
                            <i className="icon-lock" />
                          </InputGroupText>
                          <Input
                            type="password"
                            placeholder="New Password"
                            name="password"
                            invalid={errors.password !== ''}
                            value={this.state.inputs.password}
                            onChange={this.handleChangeInput}
                          />
                          <FormFeedback>{errors.password}</FormFeedback>
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup className="mb-4">
                          <InputGroupText>
                            <i className="icon-lock" />
                          </InputGroupText>
                          <Input
                            type="password"
                            placeholder="Confirm Password"
                            name="confirmPassword"
                            invalid={errors.confirmPassword !== ''}
                            value={this.state.inputs.confirmPassword}
                            onChange={this.handleChangeInput}
                          />
                          <FormFeedback>{errors.confirmPassword}</FormFeedback>
                        </InputGroup>
                      </FormGroup>
                      <PasswordRequirements
                        password={this.state.inputs.password}
                        confirmation={this.state.inputs.confirmPassword}
                      />
                      <Row>
                        <Col>
                          <Button
                            block
                            color="primary"
                            size="lg"
                            disabled={loadingShow}
                          >
                            Submit
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  logoUrl: state.settings.logoUrl
    ? state.settings.logoUrl
    : constants.DEFAULT_LOGO_URL,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset);
